import { Element } from '@/components/Elements';

import type { PanelContentProps } from '../types';

export function PodcastsPanel({ elements }: PanelContentProps) {
    if (elements.length === 0) {
        return (
            <div className="flex flex-col justify-center items-center py-8 text-center">
                <p className="text-muted-foreground text-sm">
                    No podcasts available
                </p>
                <p className="mt-1 text-muted-foreground text-xs">
                    Generated podcasts will appear here
                </p>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            {elements.map((element) => (
                <Element key={element.id} element={element} />
            ))}
        </div>
    );
}
